
import React from 'react';
import ReactDOM from 'react-dom';
import Header from '/home/circleci/app/node_modules/@fiverr-private/header/entries/LoggedOut';

const element = typeof document !== 'undefined' && document.querySelector('#Header');

if (element) {
    const props = window.initialData['Header'];

    ReactDOM.hydrate(
        <Header {...props}/>,
        element
    );
}

export default Header;
